import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { CharInspector } from "../components/CharInspector";
import { CiBreadcrumb } from "../components/CiBreadcrumb";
import { CiExplainer } from "../components/CiExplainer";

export function CharInspectorPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <CiBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.ci_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.ci_intro()}
          </p>
        </header>

        <CharInspector />

        <CiExplainer
          howTo={m.ci_howto()}
          faqs={[
            { q: m.ci_faq1_q(), a: m.ci_faq1_a() },
            { q: m.ci_faq2_q(), a: m.ci_faq2_a() },
            { q: m.ci_faq3_q(), a: m.ci_faq3_a() },
            { q: m.ci_faq4_q(), a: m.ci_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
